import * as angular from 'angular';

import { isEditMode } from '../../common/events';
import { IstateAuthorizationService, IConfigurationService } from '../../services';
import { ComponentDefinition } from '../../models';

export interface IStateIcon {
    sref: string;
    icon: string;
    tooltip: string;
    order: number;
}

class SubstateNavigationController implements angular.IComponentController {
    isLoading: boolean;
    routes: IStateIcon[] = [];
    isEditMode: boolean;
    state: string;
    hiddenStates: string[];
    isMobileMode: boolean;

    static $inject = [
        '$scope',
        '$state',
        'stateAuthorizationService',
        'configurationService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$state: angular.ui.IStateService,
        private _stateAuthorizationService: IstateAuthorizationService,
        private _configurationService: IConfigurationService
    ) {
    }

    $onInit() {
        this.routes = this.getRoutes();
        this._$scope.$on(isEditMode, (event, data) => {
            this.isEditMode = !!data;
        });
    }

    getRoutes(): IStateIcon[] {
        const hasExperimentalFeatures = !!this._configurationService.configuration.useExperimentalFeatures;
        let visibleStates = this._$state.get()
            .filter(s => s.name.indexOf(this.state + '.') === 0
                && !s.abstract
                && this._stateAuthorizationService.canAccess(s.name)
                && (!this.isEditMode || !!s.data.isMobileVisible))
            .filter(s => {
                if (hasExperimentalFeatures) {
                    return true;
                } else {
                    return !s.data || !s.data.isExperimental;
                }
            });
        if (this.hiddenStates && this.hiddenStates.length) {
            visibleStates = visibleStates.filter(s => {
                const stateName = s.name ?? '';
                return this.hiddenStates.filter(hs => stateName.indexOf(hs) > 0).length === 0;
            });
        }
        return visibleStates
            .sort((a, b) => a.data.sortingOrder - b.data.sortingOrder)
            .map(s => {
                return {
                    sref: s.name,
                    icon: s.data.icon,
                    tooltip: s.data.displayName,
                    order: s.data.sortingOrder
                };
            });
    }
}

export const wtSubstateNavigation: ComponentDefinition = {
    componentId: 'wtSubstateNavigation',
    controller: SubstateNavigationController,
    template: require('./substateNavigation.component.html'),
    controllerAs: 'vm',
    bindings: {
        state: '@',
        opts: '<?',
        allowNavigation: '<?',
        hiddenStates: '<?',
        isMobileMode: '<?'
    }
};
